import { FC, ReactNode } from "react";
import Typography from "../Typography";

type UseCaseStripProps = {
  sectionTitle: ReactNode;
  intro?: ReactNode;
  items: string[];
};

// Pill row used on page 12 (highlight-video-maker) between
// PersonaGrid and FeatureGrid to surface the breadth of supported
// source types. Renders as wrapped flex-row badges.
const UseCaseStrip: FC<UseCaseStripProps> = ({
  sectionTitle,
  intro,
  items,
}) => {
  return (
    <section className="max-w-5xl mx-auto px-3 md:px-12 my-32 md:my-48 text-center">
      <Typography
        variant="h2"
        component="h2"
        className="max-w-3xl mx-auto"
      >
        {sectionTitle}
      </Typography>
      {intro && (
        <Typography
          variant="body1"
          className="mt-6 text-slate-500 max-w-2xl mx-auto"
        >
          {intro}
        </Typography>
      )}
      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        {items.map((item) => (
          <span
            key={item}
            className="inline-flex items-center px-4 py-2 rounded-full bg-slate-100 text-slate-800 text-sm font-medium"
          >
            {item}
          </span>
        ))}
      </div>
    </section>
  );
};

export default UseCaseStrip;
